export default {
    header: {
        forum: 'Forum',
        forumdetails: 'Details',
        speakers: 'Guests',
        speakersinfo: 'Guest information',
        companyinfo: 'Company information',
        news: 'NEWS',
        views: 'Views',
        faq: 'FAQ',
        back: 'Back',
        footprint: 'Footprint',
        login: 'Login/Register',
        records: 'My footprint',
        Login: 'Login',
        Loginsucess: 'Sign in successfully',
        Logout: 'Logout',
        logoutsucess: 'Sign out successfully',
        confirmLogoutTitle: 'Are you sure to log out？',
        confirmLogoutYes: 'yes',
        confirmLogoutNo: 'no'
    },
    home: {
        meetingtime: 'Meeting Time',
        days: 'Day | Days',
        hours: 'H',
        minutes: 'M',
        seconds: 'S',
        fordetails: 'For details',
        exhibiton: '<b>VR</b><br>Exhibiton',
        forum: 'Forum',
        news: 'NEWS',
        speakers: 'Guests',
        partners: 'Partners',
        more: 'More',
        all: 'All',
        contact: 'Contact us',
        tel: '联系我们',
        email: 'E-mail',
        applets: 'WeChat Mini Program',
        microstation: '微信公众号',
        subscription: 'I MianYang',
        notice: 'Please read and agree to',
        agreement: 'User Agreement',
        privacy: 'Privacy Policy',
        statement: 'Statement of the official website',
        rightProtection: 'Intellectual property protection',
        askme: 'AI service',
        visitors: 'Visit',
        people: '',
        hosts: '主办单位',
        hostsInfo: '四川省发展和改革委员会<br>中共四川省委网络安全和信息化委员会办公室',
        undertake: '承办单位',
        undertakeInfo: '四川封面传媒有限责任公司',
        support: '支持单位',
        supportInfo: '封面传媒有限责任公司',
        hostsTechnology: 'Ministry of Science and Technology of the People\'s Republic of China',
        hostsGovernment: 'The People\'s Government of Sichuan Province',
        hostsTechnologyUrl: 'http://en.most.gov.cn/eng/index.htm',
        hostsGovernmentUrl: 'http://www.sc.gov.cn/english/',
        activityStatus: '即将呈现 | 进行中... | 已结束',
        activityBtnStatus: '查看更多 | 点击进入 | 精彩回顾'
    },
    forum: {
        agenda: 'Schedule',
        guests: 'Special Guests',
        schedule: 'Schedule',
        status: 'Live | Replay | end',
        notice: 'Countdown'
    },
    channel: {
        latest: 'Latest Report',
        special: 'Special Report',
        more: 'More',
        source: '',
        author: ''
    },
    faq: {
        faq: 'FAQ'
    },
    login: {
        phonePlaceholder: 'phone number',
        verificationCode: 'verification code',
        codePlaceholder: 'verification code',
        countdown: '{seconds}s',
        login: 'Submit',
        codefail: 'Failed to get verification code, please try again later',
        enphone: 'Enter Phone number',
        phoneerr: 'Phone number format is incorrect',
        encode: 'please enter verification code',
        codeerr: 'Please enter 6 digits',
        codeerr1: 'Verification code error',
        agree: 'I agree to the ',
        agreement: 'User Agreement',
        privacy: 'Privacy Policy',
        accountNumber: 'Required',
        isAccountNumber: 'Account does not exist',
        accountPassword: 'Incorrect password',
    },
    footprint: {
        title: 'My footprint',
        nostart: 'The exhibition has not started, no footprints',
        nodata: 'No footprints',
        Watchexhibition: 'Watch exhibition',
        sign: 'Please sign in',
        login: 'Login/Register',
        content1: 'From',
        content2: 'till now',
        content3: 'Visited the exhibition',
        content4: 'times',
        content5: 'Visited',
        content6: 'exhibition areas',
        content13: ' and ',
        content7: 'exhibition halls',
        content8: 'Visited',
        content9: 'exhibits',
        content10: 'I like this exhibit the most, it stayed for',
        content11: 'seconds',
        content12: 'The following exhibit is the most popular',
        share: 'Share',
        code: 'Scan QR code',
        save: 'Long press to save picture',
        imgLoaing: 'Picture is being generated...',
        imgerror: 'Error'
    },
    load: {
        loading: 'loading...',
        more: 'more',
        nomore: 'No more content'
    },
    default: {
        empty: 'Content temporarily not available',
        connection: 'Network connection is failed',
        failed: 'Loading failed, please try again later'
    },
    activity: {
        status: 'Coming soon | In progress | Ended',
        btnStatus: 'Enter the activity | Review'
    }
}
